import React, {useEffect} from 'react';
import {Text} from '@gravity-ui/uikit';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useAddCategoryGroupForm} from '../../model';
import {useCategoryGroupImageUpload} from '../../lib';
import {CategoryGroupImageUploadButton} from '../CategoryGroupImageUploadButton';
import styles from './AddCategoryGroupModal.module.scss';

interface AddCategoryGroupModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const AddCategoryGroupModal = ({open, setOpen}: AddCategoryGroupModalProps) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    isLoading,
    submitError,
    resetForm,
    submitForm,
  } = useAddCategoryGroupForm({setOpen});

  const {uploadId, isUploading, uploadImage, resetUpload} = useCategoryGroupImageUpload();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Группа категорий',
    title: 'Ошибка при добавлении группы категорий',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  useEffect(() => {
    if (open) {
      resetForm();
      resetUpload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    setFieldValue('imageUploadId', uploadId || null);
  }, [uploadId, setFieldValue]);

  const handleFileSelect = (file: File) => {
    uploadImage(file);
  };

  const handleRemoveImage = () => {
    resetUpload();
    setFieldValue('imageUploadId', null);
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Добавить группу'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}
        isDisabled={isUploading}>
        <FormInput
          label="Название группы"
          placeholder="Название группы"
          name="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.name && errors.name}
        />
        <FormInput
          label="Порядок показа"
          placeholder="Порядок показа"
          name="order"
          type="number"
          value={values.order.toString()}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.order && errors.order}
        />
        <div className={styles.fieldContainer}>
          <Text variant="subheader-1" className={styles.label}>
            Изображение
          </Text>
          <CategoryGroupImageUploadButton
            isUploading={isUploading}
            onFileSelect={handleFileSelect}
            onRemove={handleRemoveImage}
          />
          {touched.imageUploadId && errors.imageUploadId && (
            <Text variant="caption-2" color="danger" className={styles.errorText}>
              {errors.imageUploadId}
            </Text>
          )}
        </div>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
